module.exports = __webpack_public_path__ + "img/svg/mobile-logo.6568c67f6184ca2a81b33321e854db0d.svg";